import * as React from 'react';
import { cn } from '../lib/cn.js';

export function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'flex min-h-24 w-full rounded-control border border-border-strong bg-surface',
        'px-3 py-2 text-body text-ink transition-colors duration-[var(--duration-exit)] ease-standard',
        'placeholder:text-faint field-sizing-content',
        'disabled:cursor-not-allowed disabled:bg-surface-sunken disabled:text-muted',
        'aria-invalid:border-danger',
        className,
      )}
      {...props}
    />
  );
}
